import ProductPage, { ProductPageRouteParams, productPageGetServerSideProps } from 'components/Pages/ProductPage';
import { GetServerSidePropsContext } from 'next';
import { getCommonServerSideProps } from 'server/getCommonServerSideProps';
import { parseContextLocale } from 'utils/parseContextLocale';
import { parseRouteParams } from 'utils/parseRouteParams';
import { MarketCodesEnum } from 'constants/markets';

// This is the finnish Product page
export default ProductPage;

export async function getServerSideProps(context: GetServerSidePropsContext<ProductPageRouteParams>) {
    const [slug] = parseRouteParams(context, ['slug'], (params) => params.join('/'));

    const { market } = await parseContextLocale(context);

    const isNotFinnishMarket = market !== MarketCodesEnum.Finland;
    if (isNotFinnishMarket) {
        return {
            redirect: {
                destination: `/produkter/${slug}`,
                permanent: true,
            },
        };
    }

    const response = await productPageGetServerSideProps(context);

    if ('redirect' in response || 'notFound' in response) {
        return response;
    }

    return getCommonServerSideProps({ context, additionalProps: response });
}
